const queryFiltersMappings = {
  between: (key, value) => {
    return [key.replace(/:between/g, ''), value]
  },
  in: (key, values) => {
    const formattedValues = values.map(value => `${value}`)
    return [key.replace(/:in/g, ''), formattedValues.join(',')]
  },
  is: (key, value) => {
    return [key.replace(/:is/g, ''), value]
  }
}

const filterMappings = {
  'external_date:between': queryFiltersMappings.between,
  'external_customer_id:in': queryFiltersMappings.in,
  'branch_id:in': queryFiltersMappings.in,
  'integrated:is': queryFiltersMappings.is,
}

export default filterMappings
